export class SetTimezone {
    public static readonly type = '[RootState] Set timezone';

    constructor(public timezone = 'UTC') { }
}
